import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactCard = () => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/20 rounded-lg p-6 liquid-shadow">
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="Shield" size={24} color="white" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-poppins font-bold text-primary mb-2">
            Privacy Questions?
          </h3>
          <p className="text-text-secondary mb-4 text-sm leading-relaxed">
            Have questions about our privacy practices or want to exercise your data rights? 
            Our privacy team is here to help you understand how we protect your information.
          </p>
          <div className="space-y-2 mb-4">
            <div className="flex items-center text-sm text-text-primary">
              <Icon name="Mail" size={16} className="mr-2 text-accent" />
              <span>privacy@mava.com</span>
            </div>
            <div className="flex items-center text-sm text-text-primary">
              <Icon name="Phone" size={16} className="mr-2 text-accent" />
              <span>+91 98765 43210</span>
            </div>
            <div className="flex items-center text-sm text-text-primary">
              <Icon name="Clock" size={16} className="mr-2 text-accent" />
              <span>Response within 48 hours</span>
            </div>
          </div>
          <Button variant="outline" size="sm" className="w-full sm:w-auto">
            <Icon name="MessageCircle" size={16} className="mr-2" />
            Contact Privacy Team
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;